import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import ProductIssuesRow from '../ProductIssuesRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class ProductIssuesTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        ecommerceCategory: PropTypes.shape({
          productIssues: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const { props } = this;

    const toggles = [
      { identifier: 'error', label: <Translate content='crawler_severity_error' />, severity: 1 },
      { identifier: 'warning', label: <Translate content='crawler_severity_warning' />, severity: 2 }
    ];

    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={props.onGraphQLCheckboxInputChange('levels', toggles)}
            checkedItems={props.filters.levels}
            groups={toggles}
            name='levels'
            label={<Translate content='crawler_product_issues_severities' />}
          />
          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='ecommerce' section='productIssues'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_product_issue_message' size='8' />
            <Translate content='crawler_source_page_url' size='4' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={ProductIssuesRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(ProductIssuesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment ProductIssuesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        levels: {type: "[String!]", defaultValue: []},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }}
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              productIssues(offset: $offset, limit: $limit, levels: $levels, sourceUrl: $sourceUrl) {
                count
                edges {
                  node {
                    ...ProductIssuesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query ProductIssuesTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $levels: [String!],
        $sourceUrl: TextFilters) {,
        project (host: $host) {
          ...ProductIssuesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            levels: $levels,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
